import {
  BrandLocationPayload,
  BrandLocations,
  BrandList,
} from "models/brandLocation";
import axiosClient from "./axiosClient";
import { ApiResponse, RemovePayload } from "models";

const brandLocationApi = {
  getCustomerList(): Promise<any> {
    return axiosClient.get(`/customer/getAllCustomer`, {
      params: { disablePagination: true }
    });
  },

  getBrandsLocationList(data: BrandLocationPayload): Promise<BrandLocations> {
    return axiosClient.get(`/brandLocationManage/getAllBrandLocation`, {
      params: {
        limit: data.limit,
        page: data.page,
        region: data.region,
        search: data.search,
        sortField: data.sortName,
        sortType: data.sortType,
        isActive: data.isActive,
      }
    });
  },

  addBrandLocation(data: BrandLocations): Promise<ApiResponse> {
    return axiosClient.post(`/brandLocationManage/addBrandLocation`, data);
  },

  updateBrandLocation(data: BrandLocations): Promise<ApiResponse> {
    return axiosClient.put(`/brandLocationManage/updateBrandLocation`, data);
  },

  deleteBrandLocation(data: RemovePayload): Promise<ApiResponse> {
    // Note: Converted to use post but passing the target ID effectively as params for consistency
    // Although standard REST says this should be delete
    return axiosClient.post(`/brandLocationManage/removeBrandLocation`, null, {
      params: { id: data._id }
    });
  },

  brandListApi(data: BrandList): Promise<ApiResponse> {
    return axiosClient.get(`/brand/getBrandByCustomerId`, {
      params: { customerID: data.customerId }
    });
  },
};

export default brandLocationApi;
